<template>
  <div class="receipt-container">
    <div class="receipt-header">
      <h3>Чек №{{ receipt.receiptId }}</h3>
      <p>
        <span class="receipt-date">{{ receipt.createdAt | date('DD.MM.YYYY') }}</span>
        <span class="receipt-time">{{ receipt.createdAt | date('HH:mm') }}(Z)</span>
      </p>
    </div>
    <div v-if="isAnnulled" class="receipt-annulled">
      <h3>Аннулирован</h3>
      <p>Дата: {{ receipt.deletedAt | date('DD.MM.YYYY') }}</p>
      <p>Причина: {{ receipt.reason }}</p>
    </div>
    <div class="receipt-user">
      <div v-if="isOwner" class="receipt-user-owner">
        <p>{{ displayOwnerData }}</p>
        <p data-private>ИНН: {{ receipt.taxPayerInn }}</p>
      </div>
      <div class="receipt-user-partner">
        <p>Чек сформировал: {{ receipt.projectName }}</p>
        <p data-private>ИНН: {{ receipt.partnerPlatformInn }}</p>
      </div>
      <div class="receipt-user-type">
        Режим НО: НПД
      </div>
    </div>
    <div class="receipt-content">
      <div class="receipt-content-description">
        <p><strong>Наименование</strong></p>
        <p>{{ receipt.description }}</p>
      </div>
      <div class="receipt-content-amount">
        <p><strong>Сумма</strong></p>
        <p>{{ displayReceiptAmount }}</p>
      </div>
    </div>
    <div class="receipt-total">
      <div class="receipt-total-title">Итого:</div>
      <div class="receipt-total-summary">{{ displayReceiptAmount }}</div>
    </div>
    <div class="receipt-code">
      <img :src="qrCode" alt="" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { formatAmount } from 'lib/utils/amount';

export default {
  name: 'ReceiptSelfEmployed',
  props: {
    receipt: {
      type: Object,
      required: true,
    },
    qrCode: {
      type: String,
      required: true,
    },
  },
  computed: {
    isAnnulled() {
      return this.$validate.isNotNull(this.receipt.deletedAt);
    },
    isOwner() {
      const { firstName, secondName } = this.receipt;

      return this.$validate.isNotUndefined(secondName) && this.$validate.isNotUndefined(firstName);
    },
    displayOwnerData() {
      if (this.isOwner) {
        return `${this.receipt.secondName} ${this.receipt.firstName} ${this.receipt.patronymic}`;
      }

      return '';
    },
    displayReceiptAmount() {
      // TODO: CPME-4520 @danealton валюта должна браться из платежа, а не из проекта
      return formatAmount(this.receipt.amount, this.PROJECT_INFO.currency);
    },
    ...mapState(['PROJECT_INFO']),
  },
};
</script>

<style lang="sass" scoped>
  .receipt-container
    padding: 30px
    background-color: #fff
    color: #000
    border-radius: 10px

  .receipt-header
    margin-bottom: 20px
    padding-bottom: 20px
    border-bottom: 1px solid #eee

    h3
      margin-bottom: 10px
      font-size: 20px

  .receipt-date
    margin-right: 50px

  .receipt-annulled
    margin-bottom: 20px
    padding-bottom: 15px
    border-bottom: 1px solid #eee

    h3
      font-size: 1.2rem
      line-height: 1.6rem

    p
      font-size: .9rem
      line-height: 1.6rem

  .receipt-user
    margin-bottom: 20px
    padding-bottom: 15px
    border-bottom: 1px solid #eee

  .receipt-user-owner
    margin-bottom: 10px
    font-size: .9rem

  .receipt-user-partner
    margin-bottom: 10px
    font-size: .8rem

  .receipt-user-type
    font-size: .9rem

  .receipt-content
    display: flex
    margin-bottom: 20px
    padding-bottom: 15px
    border-bottom: 1px solid #eee

    p
      margin-bottom: 10px
      line-height: 2rem
      word-break: break-all

      &:last-child
        margin-bottom: 0
        font-size: .9rem
        line-height: 1rem

  .receipt-content-description
    flex: 1
    margin-right: 20px

  .receipt-content-amount
    text-align: right

  .receipt-total
    display: flex
    justify-content: space-between
    margin-bottom: 20px
    padding-bottom: 15px
    font-weight: 600
    font-size: 16px
    border-bottom: 1px solid #eee

  .receipt-code
    text-align: center
    font-size: 0

    img
      width: 100%
      max-width: 120px
</style>
